"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportAbuse = void 0;
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
function reportAbuse(_a) {
    var data = _a.data;
    var variables = {
        data: data,
    };
    return {
        mutation: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      mutation($data: AbuseCreateInput!) {\n        createAbuse(data: $data) {\n          id\n        }\n      }\n    "], ["\n      mutation($data: AbuseCreateInput!) {\n        createAbuse(data: $data) {\n          id\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.reportAbuse = reportAbuse;
var templateObject_1;
